import Emittery from 'emittery';

let instance: Emittery;

export const getEmittery = () => {
  if (instance) { return instance; }

  instance = new Emittery();
  return instance;
};
